export default __webpack_public_path__ + "static/media/4095.54a3553f.jpeg";